import type { CaptureResult } from 'posthog-js';

/** Event property that records which Angular configuration sent the event. */
export const POSTHOG_ENVIRONMENT_PROPERTY = 'environment';

export const POSTHOG_PRODUCTION_ENVIRONMENT = 'production';

/** Configurations whose events should stay out of production insights. */
export const POSTHOG_NON_PRODUCTION_ENVIRONMENTS = [
  'prod-local',
  'development',
  'local',
  'trav',
] as const;

/**
 * Writes the build's environment onto an outgoing PostHog event.
 * Returns null unchanged so a dropped event stays dropped.
 */
export function stampPosthogEnvironment(
  event: CaptureResult | null,
  environmentName: string,
): CaptureResult | null {
  if (!event) {
    return event;
  }

  event.properties[POSTHOG_ENVIRONMENT_PROPERTY] = environmentName;
  return event;
}
